import type { TrackingEvent } from '@marketplace-web/observability/event-tracker-data'

type UserKybSuccessEventArgs = {
  businessAccountId: number
}

export const userKybSuccessEvent = (args: UserKybSuccessEventArgs): TrackingEvent => {
  return {
    event: 'user.kyb_success',
    extra: {
      business_account_id: args.businessAccountId,
    },
  }
}
